import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "md:flex justify-between items-center mb-2 md:mb-6 px-4 md:px-6 border-b pb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-medium leading-6 text-gray-900" }, "Offering Memorandum"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, "Let's tell our borrower's story")
], -1)
const _hoisted_3 = { class: "flex justify-start md:justify-end items-center mt-4 md:mt-0" }
const _hoisted_4 = {
  key: 0,
  class: "relative"
}
const _hoisted_5 = { class: "mt-4 md:mt-8" }
const _hoisted_6 = { class: "mt-4" }
const _hoisted_7 = { class: "bg-gray-100 py-4 px-4 md:px-6 mb-2 md:mb-8 border-t border-b" }
const _hoisted_8 = { class: "fw-bold my-0 text-gray-600" }
const _hoisted_9 = { class: "mt-4 md:mt-8" }
const _hoisted_10 = { class: "bg-gray-100 py-4 px-4 md:px-6 mb-2 md:mb-8 border-t border-b" }
const _hoisted_11 = { class: "fw-bold my-0 text-gray-600" }
const _hoisted_12 = { class: "pt-4 mt-4 border-t-2 grid grid-cols-8 gap-2 md:gap-6 px-4 md:px-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-8 md:col-span-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 text-sm md:pt-2 m-0" }, " + Add data point ")
], -1)
const _hoisted_14 = { class: "col-span-8 md:col-span-5" }
const _hoisted_15 = { class: "mt-4 md:mt-8" }
const _hoisted_16 = { class: "bg-gray-100 py-4 px-4 md:px-6 mb-2 md:mb-8 border-t border-b" }
const _hoisted_17 = { class: "fw-bold my-0 text-gray-600" }
const _hoisted_18 = {
  key: 0,
  class: "row px-4 md:px-6 mb-8"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "There are no documents yet...", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h3", { class: "px-4 md:px-6 text-lg font-medium leading-6 text-sky mb-4" }, "New documents", -1)
const _hoisted_22 = { class: "pt-4 mt-4 border-t-2 grid grid-cols-8 gap-2 md:gap-6 px-4 md:px-6 pb-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-8 md:col-span-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 text-sm md:pt-2 m-0" }, " + Add document ")
], -1)
const _hoisted_24 = { class: "col-span-8 md:col-span-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EyeIcon = _resolveComponent("EyeIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_deal_owner = _resolveComponent("deal-owner")!
  const _component_deal_pictures_upload = _resolveComponent("deal-pictures-upload")!
  const _component_deal_editor_field = _resolveComponent("deal-editor-field")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_deal_add_data_point = _resolveComponent("deal-add-data-point")!
  const _component_deal_grouped_documents = _resolveComponent("deal-grouped-documents")!
  const _component_deal_documents_queue = _resolveComponent("deal-documents-queue")!
  const _component_deal_add_document = _resolveComponent("deal-add-document")!

  return (_openBlock(), _createElementBlock("form", {
    class: "bg-white rounded-lg shadow py-4 max-w-7xl mx-auto",
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFormSubmit && _ctx.handleFormSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: _normalizeClass(["px-3 py-2 bg-white border text-sm rounded-md hover:border-gray-400 mr-2 flex items-center", { 'opacity-50 pointer-events-none': !_ctx.deal.offeringMemorandumId }]),
          to: `/offering-memorandum/${_ctx.deal.offeringMemorandumId || ''}`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_EyeIcon, { class: "w-4 h-4 mr-1" }),
            _createTextVNode(" Preview ")
          ]),
          _: 1
        }, 8, ["class", "to"]),
        _createElementVNode("button", {
          type: "submit",
          class: _normalizeClass(["px-3 py-2 bg-indigo-100 hover:bg-sky text-sky hover:text-white text-sm rounded-md flex items-center", { 'opacity-50 pointer-events-none': !_ctx.formIsValid || _ctx.loading }])
        }, [
          _createVNode(_component_CheckIcon, { class: "w-4 h-4 mr-1" }),
          _createTextVNode(" Save and continue ")
        ], 2)
      ])
    ]),
    (_ctx.formIsReady)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_base_spinner, {
                key: 0,
                class: "absolute top-0 left-0 z-10 h-80",
                transparent: true
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass({ 'opacity-40': _ctx.loading })
          }, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.deal.offeringMemorandumId)
                ? (_openBlock(), _createBlock(_component_deal_owner, {
                    key: 0,
                    label: 'Deal owner',
                    value: _ctx.om.advisor,
                    class: "pb-4 md:mb-4 border-b px-4 md:px-6",
                    onOwnerChanged: _ctx.handleOwnerChange
                  }, null, 8, ["value", "onOwnerChanged"]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.omData.fields, (field) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: field.name
                }, [
                  (field.type == 'gallery-uploader')
                    ? (_openBlock(), _createBlock(_component_deal_pictures_upload, {
                        key: 0,
                        label: field.label || field.name,
                        class: _normalizeClass({
                'pb-4 md:mb-4 border-b px-4 md:px-6': true
              }),
                        value: field.value,
                        onUpdatePicturesQueue: _ctx.updatePicturesQueue,
                        onRemovePictures: _ctx.updatePicturesRemovalQueue
                      }, null, 8, ["label", "value", "onUpdatePicturesQueue", "onRemovePictures"]))
                    : (_openBlock(), _createBlock(_component_deal_editor_field, {
                        key: 1,
                        label: field.label || field.name,
                        value: field.value,
                        type: field.type,
                        name: field.name,
                        class: _normalizeClass({
                'pb-4 md:mb-4 border-b': field.name !== 'investmentHighlights',
                'px-4 md:px-6': true
              }),
                        placeholder: field.placeholder || '',
                        onUpdated: _ctx.onFieldChanged
                      }, null, 8, ["label", "value", "type", "name", "class", "placeholder", "onUpdated"]))
                ], 64))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.borrowerData.label), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.borrowerData.fields, (field) => {
                return (_openBlock(), _createBlock(_component_deal_editor_field, {
                  key: field.name,
                  label: field.label || field.name,
                  value: field.value,
                  type: field.type,
                  name: field.name,
                  disabled: field.disabled,
                  class: _normalizeClass({
              'px-4 md:px-6': true,
              'pb-4 md:mb-4 border-b': field.name !== 'phone'
            })
                }, null, 8, ["label", "value", "type", "name", "disabled", "class"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.answersData.label), 1)
              ]),
              (_ctx.answersData.fields)
                ? (_openBlock(), _createBlock(_component_draggable, {
                    key: 0,
                    modelValue: _ctx.answersData.fields,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.answersData.fields) = $event)),
                    class: "divide-y"
                  }, {
                    item: _withCtx(({ item }) => [
                      _createVNode(_component_deal_editor_field, {
                        "visibility-control": true,
                        "is-visible": _ctx.collectedData[item.name] ? _ctx.collectedData[item.name].isVisible : item.isVisible,
                        value: item.value,
                        name: item.name,
                        label: _ctx.questionsAsObject[item.name]?.label || item.name,
                        type: _ctx.questionsAsObject[item.name]?.type || item.type,
                        appearance: _ctx.questionsAsObject[item.name]?.appearance,
                        options: _ctx.questionsAsObject[item.name]?.options,
                        placeholder: _ctx.questionsAsObject[item.name]?.hint,
                        class: _normalizeClass({
                  'px-4 md:px-6 my-4': true
                }),
                        onUpdated: _ctx.onFieldChanged
                      }, null, 8, ["is-visible", "value", "name", "label", "type", "appearance", "options", "placeholder", "onUpdated"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_deal_add_data_point, {
                    questions: _ctx.questionsAsObject,
                    data: _ctx.answersData.fields,
                    onUpdated: _ctx.handleNewDataPoint
                  }, null, 8, ["questions", "data", "onUpdated"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.documentsData.label), 1)
              ]),
              (!_ctx.documentsData.fields.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                : (_openBlock(), _createBlock(_component_deal_grouped_documents, {
                    key: 1,
                    documents: _ctx.documentsData.fields,
                    "removed-documents": _ctx.queues.documentsRemoval,
                    onUpdated: _ctx.updateDocument,
                    onRemoveDocument: _ctx.updateDocumentsRemovalQueue
                  }, null, 8, ["documents", "removed-documents", "onUpdated", "onRemoveDocument"])),
              (_ctx.queues.documents.length)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass({ 'border-t mt-4 pt-6': _ctx.documentsData.fields.length })
                  }, [
                    _hoisted_21,
                    _createVNode(_component_deal_documents_queue, {
                      queue: _ctx.queues.documents,
                      onUpdateDocumentsQueue: _ctx.updateDocumentsQueue,
                      onRemoveDocumentFromQueue: _ctx.removeDocumentFromQueue
                    }, null, 8, ["queue", "onUpdateDocumentsQueue", "onRemoveDocumentFromQueue"])
                  ], 2))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_deal_add_document, {
                    questions: _ctx.questionsAsObject,
                    data: _ctx.documentsData.fields,
                    onAddFileToQueue: _ctx.updateDocumentsQueue
                  }, null, 8, ["questions", "data", "onAddFileToQueue"])
                ])
              ])
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ], 32))
}